import { Badge } from 'framework/ui/mui-builder';
import { SyberryTodayTaskStatus } from 'domain/people/syberryToday/types';
import { BadgeLayoutProps } from 'framework/ui/uiContract';

type SyberryTodayTaskStatusBadgeProps = {
  status: SyberryTodayTaskStatus;
};

const TASK_STATUS_VIEW: Record<
  SyberryTodayTaskStatus,
  {
    label: string;
    color: BadgeLayoutProps['color'];
  }
> = {
  [SyberryTodayTaskStatus.NEW]: {
    label: 'New',
    color: 'success',
  },
  [SyberryTodayTaskStatus.IN_PROGRESS]: {
    label: 'In progress',
    color: 'primary',
  },
  [SyberryTodayTaskStatus.RESOLVED]: {
    label: 'Resolved',
    color: 'default',
  },
};

const SyberryTodayTaskStatusBadge = ({ status }: SyberryTodayTaskStatusBadgeProps) => {
  const statusView = TASK_STATUS_VIEW[status];

  return <Badge color={statusView.color}>{statusView.label}</Badge>;
};

export default SyberryTodayTaskStatusBadge;
